import { Component } from '@angular/core';

import { NavbarComponent } from './navbar.component';

@Component({
  selector: 'app-navbar-mobile',
  templateUrl: './navbar-mobile.component.html',
  standalone: false
})
export class NavbarMobileComponent extends NavbarComponent {}
